import {
  Box,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { QcTestResultDto } from '@services/dtos'
import { FormHeader } from '../forms/FormHeader'
import { UpTransition } from '../animations'
import { getObservedValue, getQcTestResultLabel } from '@utils/qualityControl.utils'
import moment from 'moment'
import { ResultChip } from './RecordQcTestResultDialog'
import { HotLabEquipmentTypeLabels } from '@utils/constants'

export function QcResultDetailDialog({ result, open, onClose }: {
  result: QcTestResultDto
  open: boolean
  onClose: () => void
}) {
  const value = getObservedValue(result)
  const subTitle = getQcTestResultLabel(result)
  const { notes, attachment, hotLabEquipment } = result
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth TransitionComponent={UpTransition}>
      <DialogContent>
        <FormHeader
          title={'Détail contrôle qualité'}
          subTitles={subTitle ? [subTitle] : []}
          onClose={onClose}
          isSubmitting={false}
          showSubmit={false} />
        <Box display="flex" flexDirection="column" gap={2} pt={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <ResultChip result={result.result} />
            {value && (
              <Typography variant="body2" fontWeight={500}>
                Obtenu : {value}{result.unit ? ` ${result.unit}` : ''}
              </Typography>
            )}
          </Box>
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Typography variant="caption" color="text.secondary">
              Mesuré par <strong>{result.measuredBy.firstName} {result.measuredBy.lastName}</strong> le {moment(result.measuredAt).format('DD/MM/YYYY HH:mm')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Saisi par <strong>{result.createdBy.firstName} {result.createdBy.lastName}</strong> le {moment(result.createdAt).format('DD/MM/YYYY HH:mm')}
            </Typography>
          </Box>
          {hotLabEquipment && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>Matériel de laboratoire</Typography>
              <Typography variant="body2">
                {hotLabEquipment.name}
                {hotLabEquipment.type && ` (${HotLabEquipmentTypeLabels[hotLabEquipment.type]})`}
              </Typography>
            </Box>
          )}
          {(notes || attachment) && <Divider />}
          {notes && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>Commentaire</Typography>
              <Typography variant="body2">{notes}</Typography>
            </Box>
          )}
          {attachment && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">Fichier</Typography>
              <Box display="flex" alignItems="center">
                <Typography variant="body2" sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {attachment.filename}
                </Typography>
                {attachment.url && (
                  <Tooltip title="Ouvrir le fichier">
                    <IconButton size="small" component="a" href={attachment.url} target="_blank" rel="noopener noreferrer">
                      <OpenInNewIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}
